﻿import { extend } from './helpers.js';

export default class FurilloGoogleMaps {

    constructor(element, options) {

        const defaults = {
            apiKey: '',
            mapId: '',
            onMapLoaded: function(instance) {}
        };

        this.element = element;
        this.map = null;
        this.options = extend(defaults, options);

        this.init();
    }

    init() {
        const self = this;

        (g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })({
            key: self.options.apiKey,
            v: "weekly",
            libraries: "geometry"
        });

        async function loadMap() {
            const { Map, Marker } = await google.maps.importLibrary("maps");

            const position = { lat: 63.113077, lng: 16.6372206 };

            const lat = parseFloat(self.element.getAttribute('data-position-lat'));
            const lng = parseFloat(self.element.getAttribute('data-position-lng'));

            if (!isNaN(lat))
                position.lat = lat;

            if (!isNaN(lng))
                position.lng = lng;
            
            self.map = new Map(self.element,
                {
                    zoom: 4,
                    center: position,
                    mapId: self.options.mapId,
                    disableDefaultUI: true,
                    zoomControl: true
                });

            self.options.onMapLoaded(self);

            const markerSrc = self.element.getAttribute('data-marker-src');
            if (!markerSrc || markerSrc.length === 0)
                return;
            
            const marker = new Marker({
                position: position,
                map: self.map,
                icon: {
                    url: markerSrc
                }
            });

            self.map.setZoom(13);
        };

        loadMap();

        //if (!window.google) {
        //    const script = document.createElement('script');
        //    script.id = 'googlemaps-api';
        //    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + self.options.apiKey + '&libraries=geometry';
        //    script.async = false;
        //    script.onload = function () {
        //        loadMap();
        //    };
        //    document.body.append(script);
        //} else {
        //    loadMap();
        //}
    }
}
